(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ambiente-compravel"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.ambienteCompravelBound) return;
  window.ambienteCompravelBound = true;

  const setPanelState = (section, isOpen, trigger) => {
    const panel = section.querySelector('[data-ambiente-panel]');
    const toggle = section.querySelector('[data-ambiente-toggle]');
    if (!panel || !toggle) return;

    panel.hidden = !isOpen;
    toggle.setAttribute('aria-expanded', String(isOpen));

    if (isOpen) {
      panel.focus();
    } else if (trigger) {
      toggle.focus();
    }
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-ambiente-toggle]');
    if (toggle) {
      const section = toggle.closest('.ambiente-compravel');
      if (!section) return;

      const panel = section.querySelector('[data-ambiente-panel]');
      setPanelState(section, panel?.hidden, false);
      return;
    }

    const close = event.target.closest('[data-ambiente-close]');
    if (close) {
      const section = close.closest('.ambiente-compravel');
      if (section) setPanelState(section, false, true);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('.ambiente-compravel [data-ambiente-panel]:not([hidden])').forEach((panel) => {
      const section = panel.closest('.ambiente-compravel');
      if (section) setPanelState(section, false, true);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initTrustCarousels = () => {
    document.querySelectorAll('[data-trust-carousel]').forEach((carousel) => {
      if (carousel.dataset.trustReady === 'true') return;
      carousel.dataset.trustReady = 'true';

      const track = carousel.querySelector('[data-trust-track]');
      const dots = Array.from(carousel.querySelectorAll('[data-trust-dot]'));
      if (!track || !dots.length) return;

      const updateActiveDot = () => {
        const index = Math.min(dots.length - 1, Math.max(0, Math.round(track.scrollLeft / Math.max(track.clientWidth, 1))));
        dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
      };

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
        });
      });

      track.addEventListener('scroll', () => window.requestAnimationFrame(updateActiveDot), { passive: true });
      updateActiveDot();
    });
  };

  initTrustCarousels();
  document.addEventListener('shopify:section:load', initTrustCarousels);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);



(() => {
  const storageKey = 'atelier-home-favorites';

  const getFavorites = () => {
    try {
      const items = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      return Array.isArray(items) ? items : [];
    } catch {
      return [];
    }
  };

  const saveFavorites = (items) => {
    window.localStorage.setItem(storageKey, JSON.stringify(items));
  };

  const drawer = document.querySelector('[data-favorites-drawer]');
  const overlay = document.querySelector('[data-favorites-overlay]');
  const list = document.querySelector('[data-favorites-list]');
  const empty = document.querySelector('[data-favorites-empty]');

  const updateButtons = () => {
    const favoriteIds = new Set(getFavorites().map((item) => String(item.id)));

    document.querySelectorAll('[data-favorite-id]').forEach((button) => {
      const active = favoriteIds.has(String(button.dataset.favoriteId));
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', active ? 'Remover dos favoritos' : 'Adicionar aos favoritos');
    });

    document.querySelectorAll('[data-favorites-count]').forEach((count) => {
      const total = favoriteIds.size;
      count.textContent = total;
      count.hidden = false;
    });
  };

  const renderFavorites = () => {
    if (!list || !empty) return;

    const items = getFavorites();
    list.innerHTML = '';
    empty.hidden = items.length > 0;

    items.forEach((item) => {
      const article = document.createElement('article');
      article.className = 'favorite-drawer-item';

      if (item.image) {
        const imageLink = document.createElement('a');
        imageLink.href = item.url;

        const image = document.createElement('img');
        image.className = 'favorite-drawer-item__image';
        image.src = item.image;
        image.alt = item.title || '';
        image.loading = 'lazy';

        imageLink.appendChild(image);
        article.appendChild(imageLink);
      } else {
        article.appendChild(document.createElement('span'));
      }

      const details = document.createElement('div');
      const title = document.createElement('a');
      title.className = 'favorite-drawer-item__title';
      title.href = item.url;
      title.textContent = item.title || 'Produto';

      const price = document.createElement('p');
      price.className = 'favorite-drawer-item__price';
      price.textContent = item.price || '';

      details.className = 'favorite-drawer-item__details';
      details.appendChild(title);
      details.appendChild(price);

      const actions = document.createElement('div');
      actions.className = 'favorite-drawer-item__actions';
      const hasVariants = item.hasVariants === true || item.hasVariants === 'true';
      const isUnavailable = item.available === false || item.available === 'false';

      if (hasVariants || !item.variantId) {
        const choose = document.createElement('a');
        choose.className = 'favorite-drawer-item__choose';
        choose.href = item.url;
        choose.textContent = 'Escolher opções';
        actions.appendChild(choose);
      } else {
        const add = document.createElement('button');
        add.className = 'favorite-drawer-item__add';
        add.type = 'button';
        add.dataset.favoriteAdd = item.id;
        add.textContent = isUnavailable ? 'Indisponível' : 'Adicionar ao carrinho';
        add.disabled = isUnavailable;
        actions.appendChild(add);
      }

      details.appendChild(actions);
      article.appendChild(details);

      const remove = document.createElement('button');
      remove.className = 'favorite-drawer-item__remove';
      remove.type = 'button';
      remove.dataset.favoriteRemove = item.id;
      remove.textContent = 'Remover';
      article.appendChild(remove);

      list.appendChild(article);
    });
  };

  const closeCart = () => {
    document.querySelector('cart-drawer')?.close?.();
    document.querySelector('cart-notification')?.close?.();
  };

  const openDrawer = () => {
    if (!drawer || !overlay) return;

    closeCart();

    drawer.hidden = false;
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.hidden = false;
    document.body.classList.add('favorites-drawer-open');
    renderFavorites();
  };

  const closeDrawer = () => {
    if (!drawer || !overlay) return;

    const hideDrawer = () => {
      if (!drawer.classList.contains('is-open')) {
        drawer.hidden = true;
      }
    };

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.hidden = true;
    document.body.classList.remove('favorites-drawer-open');
    drawer.addEventListener('transitionend', (event) => {
      if (event.propertyName === 'transform') {
        hideDrawer();
      }
    }, { once: true });
    window.setTimeout(hideDrawer, 300);
  };

  const favoriteFromButton = (button) => ({
    id: String(button.dataset.favoriteId),
    title: button.dataset.favoriteTitle || '',
    url: button.dataset.favoriteUrl || '',
    image: button.dataset.favoriteImage || '',
    price: button.dataset.favoritePrice || '',
    variantId: button.dataset.favoriteVariantId || '',
    hasVariants: button.dataset.favoriteHasVariants === 'true',
    available: button.dataset.favoriteAvailable === 'true'
  });

  const addFavoriteToCart = async (button, item) => {
    if (button.disabled || button.dataset.loading === 'true') return;

    button.dataset.loading = 'true';
    button.disabled = true;
    button.textContent = 'Adicionando...';

    try {
      const cart = document.querySelector('cart-drawer');
      const formData = new FormData();
      formData.append('id', item.variantId);
      formData.append('quantity', '1');

      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement?.(button);
      }

      const response = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });
      const result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || 'Não foi possível adicionar este produto.');
      }

      if (cart && typeof cart.renderContents === 'function' && result.sections) {
        const cartUpdateEvent = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS.cartUpdate : null;
        if (cartUpdateEvent && typeof publish === 'function') {
          await publish(cartUpdateEvent, {
            source: 'favorites-drawer',
            productVariantId: item.variantId,
            cartData: result
          });
        }
        closeDrawer();
        if (cart.classList.contains('is-empty')) {
          cart.classList.remove('is-empty');
        }
        cart.renderContents(result);
        return;
      }

      const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
      const cartResponse = await fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } });
      const cartData = await cartResponse.json();
      document.querySelectorAll('[data-atelier-cart-count]').forEach((counter) => {
        counter.textContent = cartData.item_count;
      });
      button.textContent = 'Adicionado';
    } catch (error) {
      button.disabled = false;
      button.textContent = 'Tente novamente';
    } finally {
      delete button.dataset.loading;
    }
  };

  const toggleFavorite = (button) => {
    const favorite = favoriteFromButton(button);
    if (!favorite.id) return;

    const items = getFavorites();
    const existingIndex = items.findIndex((item) => String(item.id) === favorite.id);

    if (existingIndex >= 0) {
      items.splice(existingIndex, 1);
    } else {
      items.push(favorite);
    }

    saveFavorites(items);
    updateButtons();
    renderFavorites();
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-favorites-toggle]');
    if (toggle) {
      event.preventDefault();
      openDrawer();
      return;
    }

    if (event.target.closest('[data-favorites-close]') || event.target.closest('[data-favorites-overlay]')) {
      closeDrawer();
      return;
    }

    const remove = event.target.closest('[data-favorite-remove]');
    if (remove) {
      const id = String(remove.dataset.favoriteRemove);
      saveFavorites(getFavorites().filter((item) => String(item.id) !== id));
      updateButtons();
      renderFavorites();
      return;
    }

    const add = event.target.closest('[data-favorite-add]');
    if (add) {
      event.preventDefault();
      const item = getFavorites().find((favorite) => String(favorite.id) === String(add.dataset.favoriteAdd));
      if (item && item.variantId && !(item.hasVariants === true || item.hasVariants === 'true')) {
        addFavoriteToCart(add, item);
      }
      return;
    }

    const favoriteButton = event.target.closest('[data-favorite-id]');
    if (favoriteButton) {
      event.preventDefault();
      event.stopPropagation();
      toggleFavorite(favoriteButton);
      openDrawer();
    }
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawer();
  });

  window.addEventListener('storage', (event) => {
    if (event.key === storageKey) {
      updateButtons();
      renderFavorites();
    }
  });

  document.addEventListener('shopify:section:load', () => {
    updateButtons();
  });

  window.setTimeout(updateButtons, 0);
  renderFavorites();
})();


  (() => {
    const desktopMenuQuery = window.matchMedia('(min-width: 990px)');
    let menus = [];

    const closeMenu = (menu) => {
      const details = menu.querySelector('details');
      if (!details) return;
      details.classList.remove('menu-opening');
      details.removeAttribute('open');
      details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    };

    const bindDesktopMenuHover = () => {
      menus = Array.from(document.querySelectorAll('.header__inline-menu header-menu'));

      menus.forEach((menu) => {
        if (menu.dataset.atelierHoverBound === 'true') return;

        const details = menu.querySelector('details');
        if (!details) return;

        let closeTimer;

        menu.addEventListener('mouseenter', () => {
          if (!desktopMenuQuery.matches) return;
          window.clearTimeout(closeTimer);
          details.setAttribute('open', '');
          details.classList.add('menu-opening');
          details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
        });

        menu.addEventListener('mouseleave', () => {
          if (!desktopMenuQuery.matches) return;
          closeTimer = window.setTimeout(() => closeMenu(menu), 140);
        });

        menu.dataset.atelierHoverBound = 'true';
      });
    };

    desktopMenuQuery.addEventListener('change', () => {
      if (!desktopMenuQuery.matches) {
        menus.forEach(closeMenu);
      }
    });

    document.addEventListener('shopify:section:load', bindDesktopMenuHover);
    bindDesktopMenuHover();
  })();


(() => {
  const styleId = 'atelier-premium-header-styles';
  const recentProductsKey = 'atelier-recent-products';
  

  const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  })[character]);

  const readRecentProducts = () => {
    try {
      const products = JSON.parse(localStorage.getItem(recentProductsKey) || '[]');
      return Array.isArray(products) ? products.slice(0, 4) : [];
    } catch (error) {
      return [];
    }
  };

  const rememberCurrentProduct = () => {
    if (!window.location.pathname.includes('/products/')) return;
    const title = document.querySelector('h1')?.textContent?.trim();
    if (!title) return;

    try {
      const currentProduct = { title, url: window.location.pathname };
      const products = readRecentProducts().filter((product) => product.url !== currentProduct.url);
      products.unshift(currentProduct);
      localStorage.setItem(recentProductsKey, JSON.stringify(products.slice(0, 4)));
    } catch (error) {
      // Itens recentes permanecem opcionais quando o armazenamento local não está disponível.
    }
  };

  const installStyles = () => {
    if (document.getElementById(styleId)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = [
      '@media screen and (min-width: 990px) {',
      '  .header .header__inline-menu { grid-column: 1 / -1 !important; width: min(98rem, calc(100% - 4rem)) !important; margin: 1.55rem auto 0; padding: 1.3rem 0; border-top: 1px solid rgba(42, 39, 38, .12); border-bottom: 0; }',
      '  .header .header__inline-menu .list-menu--inline { justify-content: center; flex-wrap: wrap; gap: 1rem 2rem; width: 100%; margin: 0; }',
      '  .header .header__inline-menu .list-menu--inline > li > .header__menu-item, .header .header__inline-menu .list-menu--inline > li > header-menu > details > .header__menu-item { padding: .2rem 0 !important; font-size: 1.35rem !important; font-weight: 500; line-height: 1.5 !important; letter-spacing: .065em !important; text-transform: none; }',
      '  .header .header__inline-menu .icon-caret { display: none !important; }',
      '  .header__icons { column-gap: 1.25rem !important; }',
      '  .header__icons .atelier-search-fallback { display: none !important; }',
      '  .atelier-premium-search { position: relative; display: flex; align-items: center; width: clamp(21rem, 24vw, 33rem); margin-right: .8rem; border-bottom: 1px solid #7A5D54; }',
      '  .atelier-premium-search:focus-within { border-bottom-color: #7A5D54; }',
      '  .atelier-premium-search__input { width: 100%; min-width: 0; height: 3.4rem; padding: 0 .35rem; border: 0 !important; border-radius: 0 !important; outline: 0 !important; box-shadow: none !important; -webkit-appearance: none; appearance: none; background: transparent !important; color: #7A5D54; font-family: inherit; font-size: 1.35rem; letter-spacing: .04em; }',
      '  .atelier-premium-search__input:focus, .atelier-premium-search__input:focus-visible { border: 0 !important; outline: 0 !important; box-shadow: none !important; }',
      '  .atelier-premium-search__input::placeholder { color: #7A5D54; opacity: 1; }',
      '  .atelier-premium-search__submit { display: grid; flex: 0 0 2.4rem; width: 2.4rem; height: 3.4rem; padding: 0; place-items: center; border: 0; background: transparent; color: #7A5D54; cursor: pointer; }',
      '  .atelier-premium-search__submit svg { width: 2.15rem; height: 2.15rem; }',
      '  .atelier-search-suggestions { position: absolute; z-index: 30; top: calc(100% + 1.1rem); right: 0; display: none; width: min(38rem, calc(100vw - 3rem)); padding: 1.8rem; border: 1px solid rgba(42, 39, 38, .12); background: rgb(var(--color-background)); box-shadow: 0 .9rem 2.8rem rgba(30, 27, 24, .12); }',
      '  .atelier-premium-search.is-open .atelier-search-suggestions { display: block; }',
      '  .atelier-search-suggestions__eyebrow { margin: 0 0 1rem; color: rgba(42, 39, 38, .58); font-size: 1.05rem; letter-spacing: .1em; text-transform: uppercase; }',
      '  .atelier-search-suggestions__list { display: grid; gap: .15rem; }',
      '  .atelier-search-suggestions__link { display: flex; align-items: center; justify-content: space-between; padding: .8rem 0; color: rgb(var(--color-foreground)); font-size: 1.35rem; text-decoration: none; }',
      '  .atelier-search-suggestions__link span { color: rgba(42, 39, 38, .55); }',
      '  .atelier-search-suggestions__divider { height: 1px; margin: 1.45rem 0; background: rgba(42, 39, 38, .12); }',
      '  .atelier-search-suggestions__all { display: inline-block; margin-top: 1.2rem; color: rgb(var(--color-foreground)); font-size: 1.2rem; font-weight: 600; letter-spacing: .06em; text-decoration: underline; text-underline-offset: .35rem; text-transform: uppercase; }',
      '}',
      '@media screen and (max-width: 989px) { .atelier-premium-search { display: none; } }',
      '@media screen and (max-width: 749px) { body.atelier-mobile-search-open .banner-carousel__arrows, body.atelier-mobile-search-open .banner-carousel__dots, body.atelier-mobile-search-open .banner-carousel__pause { visibility: hidden !important; pointer-events: none !important; } }'
    ].join('\n');
    document.head.appendChild(style);
  };

  const createLink = (label, url) => {
    const link = document.createElement('a');
    const arrow = document.createElement('span');
    link.className = 'atelier-search-suggestions__link';
    link.href = url;
    link.textContent = label;
    arrow.setAttribute('aria-hidden', 'true');
    arrow.textContent = '→';
    link.appendChild(arrow);
    return link;
  };

  const createSection = (title, items) => {
    const section = document.createElement('div');
    const eyebrow = document.createElement('p');
    const list = document.createElement('div');

    eyebrow.className = 'atelier-search-suggestions__eyebrow';
    eyebrow.textContent = title;
    list.className = 'atelier-search-suggestions__list';
    items.forEach((item) => list.appendChild(createLink(item.label, item.url)));
    section.append(eyebrow, list);
    return section;
  };

  const initPremiumSearch = () => {
    installStyles();
    rememberCurrentProduct();

    document.querySelectorAll('header.header').forEach((header) => {
      if (header.dataset.atelierPremiumSearch === 'true') return;

      const icons = header.querySelector('.header__icons');
      const existingSearch = icons?.querySelector('.header__search');
      if (!icons || !existingSearch) return;

      header.dataset.atelierPremiumSearch = 'true';
      existingSearch.classList.add('atelier-search-fallback');

      const form = document.createElement('form');
      const input = document.createElement('input');
      const submit = document.createElement('button');
      const suggestions = document.createElement('div');
      let searchDelay;

      form.className = 'atelier-premium-search';
      form.action = '/search';
      form.method = 'get';
      form.setAttribute('role', 'search');

      input.className = 'atelier-premium-search__input';
      input.type = 'search';
      input.name = 'q';
      input.autocomplete = 'off';
      input.placeholder = 'Pesquisar';
      input.setAttribute('aria-label', 'Pesquisar produtos');

      submit.className = 'atelier-premium-search__submit';
      submit.type = 'submit';
      submit.setAttribute('aria-label', 'Buscar');
      submit.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="10.8" cy="10.8" r="6.6" stroke="currentColor" stroke-width="1.7"></circle><path d="m16 16 4.4 4.4" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"></path></svg>';

      suggestions.className = 'atelier-search-suggestions';
      suggestions.setAttribute('aria-live', 'polite');
      form.append(input, submit, suggestions);
      icons.insertBefore(form, existingSearch);

      const show = (nodes) => {
        suggestions.replaceChildren(...nodes);
        form.classList.add('is-open');
      };

      const renderDefault = () => {
        const nodes = [];
        const recentProducts = readRecentProducts();

        if (recentProducts.length) {
          
          nodes.push(createSection('Vistos recentemente', recentProducts.map((product) => ({
            label: product.title,
            url: product.url
          }))));
        }

        show(nodes);
      };

      const searchProducts = async (query) => {
        const loading = document.createElement('p');
        loading.className = 'atelier-search-suggestions__eyebrow';
        loading.textContent = 'Buscando peças selecionadas…';
        show([loading]);

        try {
          const response = await fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=4');
          const data = await response.json();
          if (input.value.trim() !== query) return;

          const products = data?.resources?.results?.products || [];
          const nodes = [];

          if (products.length) {
            nodes.push(createSection('Produtos sugeridos', products.map((product) => ({
              label: product.title,
              url: product.url
            }))));
          } else {
            const empty = document.createElement('p');
            empty.className = 'atelier-search-suggestions__eyebrow';
            empty.textContent = 'Nenhum produto encontrado.';
            nodes.push(empty);
          }

          const allResults = document.createElement('a');
          allResults.className = 'atelier-search-suggestions__all';
          allResults.href = '/search?q=' + encodeURIComponent(query) + '&type=product';
          allResults.textContent = 'Ver todos os resultados';
          nodes.push(allResults);
          show(nodes);
        } catch (error) {
          if (input.value.trim() !== query) return;

          const allResults = document.createElement('a');
          allResults.className = 'atelier-search-suggestions__all';
          allResults.href = '/search?q=' + encodeURIComponent(query) + '&type=product';
          allResults.textContent = 'Ver todos os resultados';
          show([allResults]);
        }
      };

      input.addEventListener('focus', () => {
        if (input.value.trim()) {
          searchProducts(input.value.trim());
        } else {
          renderDefault();
        }
      });

      input.addEventListener('input', () => {
        window.clearTimeout(searchDelay);
        const query = input.value.trim();

        if (!query) {
          renderDefault();
          return;
        }

        searchDelay = window.setTimeout(() => searchProducts(query), 180);
      });

      input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          form.classList.remove('is-open');
          input.blur();
        }
      });

      document.addEventListener('click', (event) => {
        if (!form.contains(event.target)) form.classList.remove('is-open');
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPremiumSearch);
  } else {
    initPremiumSearch();
  }

  document.addEventListener('shopify:section:load', initPremiumSearch);
})();


(() => {
  const syncSearchTrigger = () => {
    const isDesktop = window.matchMedia('(min-width: 990px)').matches;
    document.querySelectorAll('.header__search.atelier-search-fallback').forEach((search) => {
      const trigger = search.querySelector('summary');

      if (trigger) {
        trigger.setAttribute('data-atelier-mobile-search-open', '');
        trigger.setAttribute('aria-controls', 'AtelierMobileSearchDrawer');
        trigger.setAttribute('aria-expanded', 'false');
      }

      if (isDesktop) {
        search.style.setProperty('display', 'none', 'important');
      } else {
        search.style.removeProperty('display');
      }
    });
  };

  syncSearchTrigger();
  window.addEventListener('resize', syncSearchTrigger);
  document.addEventListener('shopify:section:load', syncSearchTrigger);
})();



(() => {
  const initAtelierMobileSearch = () => {
    document.querySelectorAll('[data-atelier-mobile-search-drawer]').forEach((drawer) => {
      if (drawer.dataset.ready === 'true') return;
      drawer.dataset.ready = 'true';

      const backdrop = document.querySelector('[data-atelier-mobile-search-backdrop]');
      const input = drawer.querySelector('[data-atelier-mobile-search-input]');
      const openers = document.querySelectorAll('[data-atelier-mobile-search-open]');
      const close = () => {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        backdrop?.setAttribute('hidden', '');
        document.body.classList.remove('atelier-mobile-search-open');
        openers.forEach((opener) => opener.setAttribute('aria-expanded', 'false'));
      };
      const open = () => {
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        backdrop?.removeAttribute('hidden');
        document.body.classList.add('atelier-mobile-search-open');
        openers.forEach((opener) => opener.setAttribute('aria-expanded', 'true'));
        window.setTimeout(() => input?.focus(), 180);
      };
      openers.forEach((opener) => opener.addEventListener('click', open));
      drawer.querySelectorAll('[data-atelier-mobile-search-close]').forEach((button) => button.addEventListener('click', close));
      backdrop?.addEventListener('click', close);
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && drawer.classList.contains('is-open')) close();
      });
    });
  };
  initAtelierMobileSearch();
  document.addEventListener('shopify:section:load', initAtelierMobileSearch);
})();



(() => {
  const setPanelState = (drawerSelector, overlaySelector, open) => {
    const drawer = document.querySelector(drawerSelector);
    const overlay = document.querySelector(overlaySelector);
    if (!drawer || !overlay) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    overlay.hidden = !open;

    if (drawerSelector === '[data-atelier-mobile-search-drawer]') {
      document.body.classList.toggle('atelier-mobile-search-open', open);
    }
  };

  document.addEventListener('click', (event) => {
    const searchTrigger = event.target.closest('[data-atelier-mobile-search-open]');
    if (searchTrigger) {
      event.preventDefault();
      setPanelState('[data-atelier-mobile-search-drawer]', '[data-atelier-mobile-search-backdrop]', true);
      searchTrigger.setAttribute('aria-expanded', 'true');
      window.setTimeout(() => document.querySelector('[data-atelier-mobile-search-input]')?.focus(), 120);
      return;
    }

    const favoriteTrigger = event.target.closest('[data-favorites-toggle]');
    if (favoriteTrigger) {
      event.preventDefault();
      setPanelState('[data-favorites-drawer]', '[data-favorites-overlay]', true);
      favoriteTrigger.setAttribute('aria-expanded', 'true');
      return;
    }

    if (event.target.closest('[data-atelier-mobile-search-close]') || event.target.closest('[data-atelier-mobile-search-backdrop]')) {
      setPanelState('[data-atelier-mobile-search-drawer]', '[data-atelier-mobile-search-backdrop]', false);
      document.querySelectorAll('[data-atelier-mobile-search-open]').forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
    }

    if (event.target.closest('[data-favorites-close]') || event.target.closest('[data-favorites-overlay]')) {
      setPanelState('[data-favorites-drawer]', '[data-favorites-overlay]', false);
      document.querySelectorAll('[data-favorites-toggle]').forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
    }
  }, true);
})();


(() => {
  // Atelier: gatilhos extras abrem o cart-drawer NATIVO do Dawn 20260724
  // (o ícone do header já é aberto pelo próprio cart-drawer.js via #cart-icon-bubble)
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-atelier-open-native-cart]');
    if (!trigger) return;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return; // sem drawer, o link navega para /cart
    event.preventDefault();
    drawer.open(trigger);
  });

  // Sincroniza o contador da quickbar mobile quando o Dawn re-renderiza o ícone do header
  const syncQuickbarCartCount = () => {
    const source = document.querySelector('#cart-icon-bubble [data-atelier-cart-count]');
    if (!source) return;
    document.querySelectorAll('.atelier-mobile-quickbar [data-atelier-cart-count]').forEach((counter) => {
      counter.textContent = source.textContent;
    });
  };

  const bubble = document.getElementById('cart-icon-bubble');
  if (bubble && 'MutationObserver' in window) {
    new MutationObserver(syncQuickbarCartCount).observe(bubble, { childList: true, subtree: true });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('form[action*="/cart/add"]') || !form.closest('product-form')) return;

    window.setTimeout(() => {
      const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
      fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
        .then((response) => response.json())
        .then(({ item_count: itemCount }) => {
          document.querySelectorAll('[data-atelier-cart-count]').forEach((counter) => {
            counter.textContent = itemCount;
          });
        })
        .catch(() => {});
    }, 1200);
  }, true);
  }
  syncQuickbarCartCount();
})();

(() => {
  /* O drawer mobile usa um acordeão próprio: cada nível permanece aberto
     enquanto a subcategoria correspondente é expandida. */
  function closeDrawerDetail(detail) {
    if (!detail) return;
    detail.querySelectorAll('details[open]').forEach((nestedDetail) => {
      nestedDetail.open = false;
      nestedDetail.classList.remove('menu-opening');
      const nestedSummary = nestedDetail.querySelector(':scope > summary');
      if (nestedSummary) nestedSummary.setAttribute('aria-expanded', 'false');
    });
    detail.open = false;
    detail.classList.remove('menu-opening');
    const summary = detail.querySelector(':scope > summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('click', (event) => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    const summary = event.target.closest('header-drawer .menu-drawer details > summary');
    if (!summary) return;

    const details = summary.parentElement;
    const submenu = details && details.querySelector(':scope > .menu-drawer__submenu');
    if (!details || !submenu) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const willOpen = !details.open;
    const listItem = details.closest('li');
    const levelList = listItem && listItem.parentElement;

    if (willOpen && levelList) {
      Array.from(levelList.children).forEach((siblingItem) => {
        const siblingDetail = siblingItem.querySelector(':scope > details[open]');
        if (siblingDetail && siblingDetail !== details) closeDrawerDetail(siblingDetail);
      });
    }

    if (willOpen) {
      details.open = true;
      details.classList.add('menu-opening');
      summary.setAttribute('aria-expanded', 'true');
    } else {
      closeDrawerDetail(details);
    }
  }, true);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('image-banner-carousel')) {
  class ImageBannerCarousel extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.track = this.querySelector('[data-carousel-track]');
      this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-carousel-dot]'));
      this.previousButton = this.querySelector('[data-carousel-previous]');
      this.nextButton = this.querySelector('[data-carousel-next]');
      this.pauseButton = this.querySelector('[data-carousel-pause]');
      this.pauseLabel = this.querySelector('[data-carousel-pause-label]');
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
      this.delay = Math.max(0, Number(this.dataset.autoplayDelay) || 0);
      this.autoEnabled = this.dataset.autoplay === 'true' && this.delay > 0 && this.slides.length > 1;
      this.pauseOnHover = this.dataset.pauseOnHover === 'true';
      this.manuallyPaused = false;
      this.timer = null;
      this.pointerStart = null;

      this.previousButton?.addEventListener('click', () => this.show(this.index - 1));
      this.nextButton?.addEventListener('click', () => this.show(this.index + 1));

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.show(Number(dot.dataset.carouselDot)));
      });

      this.pauseButton?.addEventListener('click', () => this.togglePause());

      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.show(this.index - 1);
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.show(this.index + 1);
        }
      });

      this.addEventListener('pointerdown', (event) => {
        this.pointerStart = event.clientX;
      }, { passive: true });

      this.addEventListener('pointerup', (event) => {
        if (this.pointerStart === null) return;

        const distance = event.clientX - this.pointerStart;
        this.pointerStart = null;

        if (Math.abs(distance) < 45) return;
        this.show(distance > 0 ? this.index - 1 : this.index + 1);
      }, { passive: true });

      if (this.pauseOnHover) {
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
      }

      this.show(this.index, false);
      this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    show(index, restart = true) {
      if (!this.slides.length) return;

      const total = this.slides.length;
      this.index = ((index % total) + total) % total;

      if (this.dataset.effect === 'slide' && this.track) {
        this.track.style.transform = 'translate3d(-' + (this.index * 100) + '%, 0, 0)';
      }

      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      this.dots.forEach((dot, dotIndex) => {
        const active = dotIndex === this.index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      if (restart) this.restartAutoplay();
    }

    togglePause() {
      this.manuallyPaused = !this.manuallyPaused;

      if (this.manuallyPaused) {
        this.stopAutoplay();
      } else {
        this.startAutoplay();
      }

      this.updatePauseControl();
    }

    startAutoplay() {
      if (!this.autoEnabled || this.manuallyPaused || this.timer) return;

      this.timer = window.setInterval(() => {
        this.show(this.index + 1, false);
      }, this.delay);

      this.updatePauseControl();
    }

    stopAutoplay() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }

    updatePauseControl() {
      if (!this.pauseButton) return;

      const paused = this.manuallyPaused;
      const label = paused ? 'Retomar apresentação' : 'Pausar apresentação';
      this.pauseButton.setAttribute('aria-pressed', paused ? 'true' : 'false');
      this.pauseButton.setAttribute('aria-label', label);

      if (this.pauseLabel) this.pauseLabel.textContent = label;

      const path = this.pauseButton.querySelector('path');
      if (path) {
        path.setAttribute('d', paused ? 'M9 5v14l11-7z' : 'M8 6h3v12H8zM13 6h3v12h-3z');
      }
    }
  }

  customElements.define('image-banner-carousel', ImageBannerCarousel);
}


(() => {
  const counterStyleId = 'atelier-visible-carousel-counter-styles';

  const installCounterStyles = () => {
    if (document.getElementById(counterStyleId)) return;

    const style = document.createElement('style');
    style.id = counterStyleId;
    style.textContent = [
      'body .image-banner-carousel-section .banner-carousel__dots { display: none !important; }',
      'body .image-banner-carousel-section .banner-carousel__counter { position: absolute; z-index: 1; bottom: 2.1rem; left: 50%; display: inline-flex; flex: 0 0 auto; gap: .55rem; align-items: baseline; max-width: calc(100% - 4.8rem); overflow: hidden; white-space: nowrap; color: #fff; font-size: 1.35rem; font-weight: 500; letter-spacing: .12em; line-height: 1; text-overflow: clip; text-shadow: 0 .1rem .5rem rgba(0, 0, 0, .35); transform: translateX(-50%); pointer-events: none; }',
      'body .image-banner-carousel-section .banner-carousel__counter span { flex: 0 0 auto; }',
      'body .image-banner-carousel-section .banner-carousel__counter span:nth-child(2) { color: rgba(255, 255, 255, .7); }',
      '@media screen and (max-width: 749px) { body .image-banner-carousel-section .banner-carousel__counter { bottom: 1.5rem; max-width: calc(100% - 3.2rem); font-size: 1.2rem; } body:has(#Details-menu-drawer-container[open]) .image-banner-carousel-section .banner-carousel__counter, body:has(.menu-drawer-container.menu-opening) .image-banner-carousel-section .banner-carousel__counter { visibility: hidden; } }'
    ].join('\n');
    document.head.appendChild(style);
  };

  const initVisibleCarouselCounter = () => {
    installCounterStyles();

    document.querySelectorAll('image-banner-carousel').forEach((carousel) => {
      if (carousel.dataset.atelierVisibleCounter === 'true') return;

      const dots = Array.from(carousel.querySelectorAll('[data-carousel-dot]'));
      const slides = Array.from(carousel.querySelectorAll('[data-carousel-slide]'));
      const current = carousel.querySelector('[data-carousel-counter-current]');
      if (!dots.length || !current) return;

      carousel.dataset.atelierVisibleCounter = 'true';

      const update = () => {
        let index = dots.findIndex((dot) => dot.classList.contains('is-active'));
        if (index < 0) index = slides.findIndex((slide) => slide.classList.contains('is-active'));
        current.textContent = String(Math.max(index, 0) + 1);
      };

      const observer = new MutationObserver(update);
      observer.observe(carousel, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
      update();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVisibleCarouselCounter);
  } else {
    initVisibleCarouselCounter();
  }

  document.addEventListener('shopify:section:load', initVisibleCarouselCounter);
})();


  } catch(e) { console.error(e); }
})();
})();
